import RepurchaseDefinition from '../../shared/partials/repurchase-definition.pt.mdx';

export const title = 'Recompras (Gráfico)';

Gráfico que mostra a quantidade de recompras ao longo do tempo. O gráfico separa as recompras em duas categorias:
- **Recompras no app:** de clientes que compraram 2+ vezes pelo app
- **Migração de canal:** de clientes que já haviam comprado no site e fizeram o primeiro pedido pelo app
